import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { u as useSurface } from '../SurfaceProvider/SurfaceProvider-qDGZSFCj.js';

const StyledHeading = /*#__PURE__*/styled('h1').withConfig({
  componentId: "sc-storm-ui-40026394__sc-ohwmvy-0"
})(["", ";padding:0;margin:0;", ""], ({
  theme,
  $size,
  $typeface,
  $color
}) => css(["font:", ";color:", ";", " font-family:", ";letter-spacing:", ";"], theme.font.display[$size].default, $color === 'inherit' ? 'inherit' : theme.text.color[$color], isMobile(css(["font:", ";"], theme.font.display[$size].mobile)), theme.font.family[$typeface], theme.font.letterSpacing[$typeface]), ({
  theme,
  $withMargin
}) => $withMargin && css(["margin-block-start:", ";margin-block-end:", ";", ""], theme.heading.marginBlockStart.default, theme.heading.marginBlockEnd.default, isMobile(css(["margin-block-start:", ";margin-block-end:", ";"], theme.heading.marginBlockStart.mobile, theme.heading.marginBlockEnd.mobile))));

/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer
 * in the future how color is reconciled between themes and tokens.
 */
const useColor = colorProp => {
  const {
    isInverted
  } = useSurface();

  /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */
  if (isInverted) {
    return 'inverted';
  }
  return colorProp || 'default';
};
const getDefaultSizeForHeadingLevel = level => {
  switch (level) {
    case 'h1':
      return 'xxlarge';
    case 'h2':
      return 'xlarge';
    case 'h3':
      return 'large';
    case 'h4':
      return 'medium';
    case 'h5':
      return 'base';
    case 'h6':
      return 'small';
    default:
      return 'xxlarge';
  }
};
const Heading = ({
  children,
  color,
  renderAs,
  size,
  typeface = 'display',
  withMargin = false,
  ...rest
}) => {
  const derivedColor = useColor(color);
  return /*#__PURE__*/React__default.createElement(StyledHeading, _extends({}, rest, {
    as: renderAs !== null && renderAs !== void 0 ? renderAs : 'h1',
    $color: derivedColor,
    $typeface: typeface,
    $size: size || getDefaultSizeForHeadingLevel(renderAs !== null && renderAs !== void 0 ? renderAs : 'h1'),
    $withMargin: withMargin
  }), children);
};

export { Heading as H };
//# sourceMappingURL=Heading-_71dBU2D.js.map
